/** 대시보드 API 계약 전부 — 범위 행렬 테스트가 이 목록을 순회한다 */
import type { RouteDef } from '../route.ts';
import * as account from './account.ts';
import * as agency from './agency.ts';
import * as article from './article.ts';
import * as billing from './billing.ts';
import * as brand from './brand.ts';
import * as contract from './contract.ts';
import * as geoCase from './geoCase.ts';
import * as auth from './auth.ts';
import * as metrics from './metrics.ts';
import * as partner from './partner.ts';
import * as probe from './probe.ts';
import * as registry from './registry.ts';
import * as reportDispatch from './reportDispatch.ts';
import * as reportMessage from './reportMessage.ts';
import * as seo from './seo.ts';
import * as signup from './signup.ts';
import * as video from './video.ts';
import * as works from './works.ts';

function routesOf(mod: Record<string, unknown>): RouteDef[] {
  return Object.values(mod).filter(
    (v): v is RouteDef => typeof v === 'object' && v !== null && 'path' in v && 'access' in v && 'method' in v,
  );
}

export const API_ROUTES: readonly RouteDef[] = [
  ...routesOf(auth),
  ...routesOf(registry),
  ...routesOf(probe),
  ...routesOf(metrics),
  ...routesOf(seo),
  ...routesOf(signup),
  ...routesOf(works),
  ...routesOf(article),
  ...routesOf(contract),
  ...routesOf(account),
  ...routesOf(brand),
  ...routesOf(billing),
  ...routesOf(reportMessage),
  ...routesOf(reportDispatch),
  ...routesOf(geoCase),
  ...routesOf(partner),
  ...routesOf(agency),
  ...routesOf(video),
];

export {
  account,
  agency,
  article,
  auth,
  billing,
  brand,
  contract,
  geoCase,
  metrics,
  partner,
  probe,
  registry,
  reportDispatch,
  reportMessage,
  seo,
  signup,
  video,
  works,
};
